// Дополнительные действия при логине/выходе
export default async (ctx) => {
  const { store, $auth } = ctx

  async function onLogin () {
    if (!store.getters["user/user"]?.id)
      await store.dispatch("user/fetchUser")
  }

  function onLogout () {
    store.commit("user/RESET_STATE")
  }

  if ($auth.loggedIn) await onLogin()

  $auth.$storage.watchState("loggedIn", async (loggedIn) => {
    if (loggedIn) await onLogin()
    else onLogout()
  })
}
